import React from 'react'

function SsoHomePage() {
  return (
    <div>SsoHomePage</div>
  )
}

export default SsoHomePage